
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature-background-remover",
      function () {
        return require("private-next-pages/signature-background-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature-background-remover"])
      });
    }
  